import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import HeroSection from "../../components/NewProjects/HeroSection";
import Content from "../../components/NewProjects/Content";
import Footer from "../../components/Footer";
import BlueWaterImg from "../../assets/BLUEWATERSNEW.jpeg";
import DownTownImg from "../../assets/DowntownNew.jpeg";
import DubaiHillEstateImg from "../../assets/DubaiHillsNew.jpeg";
import EmiratesHills from "../../assets/emirateshills copy.jpeg";
import DubaiMarinaImg from "../../assets/dubaimarina.webp";
import PalmJebelImg from "../../assets/palmjebel.webp";
import PalmJumeirahImg from "../../assets/PalmJumeirahNEW.jpeg";
import JLT from "../../assets/JLTNEW.jpeg";
import BusinessBay from "../../assets/Businessbay.jpeg";
import EmaarBeachfront from "../../assets/EmaarBeachFront.jpeg";
import JumeirahVillageCircle from "../../assets/jumeirahVillageCity.jpeg";
import ALBarari from "../../assets/AlBarari.jpeg";
import ArabianRanches from "../../assets/ArabianRanches.jpeg";
import DubaiSiliconOasis from "../../assets/DubaiSiliconOasis.jpeg";
import DAMACHills from "../../assets/damacHills.jpeg";
import DubaiCreekHarbour from "../../assets/DubaiCreekTower.jpeg";
import MBR from "../../assets/MBRCity.jpeg";
import MotorCity from "../../assets/MotorCity.jpeg";
import ALFurjan from "../../assets/Alfurjan.jpeg";
import DubaiInvestmentPark from "../../assets/dubaiInvestmentpark copy.jpeg";
import JemeriahBeachResidence from "../../assets/jumeriahbeachresidence.jpeg";
import expoCity from "../../assets/ExpoCity.jpeg";
import {
  faBath,
  faBed,
  faRuler,
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

function NewProjects() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/properties?type=NewProject`
        );
        const approvedData = response.data.filter(
          (property) => property.status === "approved"
        );
        setData(approvedData);
        setFilterData(approvedData);
      } catch (error) {
        console.error("Error:", error);
      }
    }
    getData();
  }, []);

  const jsondata = [
    { name: "Dubai Marina", img: DubaiMarinaImg, location: "Dubai" },
    { name: "Blue Water", img: BlueWaterImg, location: "Dubai" },
    { name: "Palm Jumeirah", img: PalmJumeirahImg, location: "Dubai" },
    { name: "Palm Jebel Ali", img: PalmJebelImg, location: "Dubai" },
    { name: "Downtown", img: DownTownImg, location: "Dubai" },
    { name: "Emirates Hills", img: EmiratesHills, location: "Dubai" },
    { name: "JLT", img: JLT, location: "Dubai" },
    { name: "Dubai Hills Estate", img: DubaiHillEstateImg, location: "Dubai" },
    { name: "Business Bay", img: BusinessBay, location: "Dubai" },
    { name: "Emaar Beachfront", img: EmaarBeachfront, location: "Dubai" },
    {
      name: "Jumeirah Village Circle",
      img: JumeirahVillageCircle,
      location: "Dubai",
    },
    { name: "AL Barari", img: ALBarari, location: "Dubai" },
    { name: "Arabian Ranches", img: ArabianRanches, location: "Dubai" },
    { name: "Silicon Oasis", img: DubaiSiliconOasis, location: "Dubai" },
  ];

  function handleFilter(searchResult) {
    let filteredData = data;

    if (searchResult.city !== "Dubai") {
      filteredData = filteredData.filter((property) =>
        property.location.includes(searchResult.city)
      );
    }
    if (searchResult.propertyType !== "Any") {
      filteredData = filteredData.filter(
        (property) => property.propertyType === searchResult.propertyType
      );
    }
    if (searchResult.price !== "Any") {
      filteredData = filteredData.filter(
        (property) => parseInt(property.price) > parseInt(searchResult.price)
      );
    }
    if (searchResult.complete !== "Any") {
      filteredData = filteredData.filter(
        (property) => property.propertyStatus === searchResult.complete
      );
    }

    setFilterData(filteredData);
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />

      {/* New Section: Display Properties in a Grid Layout */}
      <section className="p-4 box-border mb-6 mx-auto w-full md:w-[80vw]">
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold font-poppins text-center tracking-wide mb-6  text-[#173d73]">
          Prime Areas
        </h1>

        {/* <Content data={filterData} /> */}

        {/* Grid Layout for Properties */}
        <section className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {jsondata.map((property, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-lg shadow-lg cursor-pointer group property-card"
              onClick={() => {
                navigate("/allProperties");
                sessionStorage.setItem("city", property.name);
              }}
            >
              <div className="relative w-full h-[35vh] overflow-hidden">
                <img
                  src={property.img}
                  alt="Downtown"
                  className="z-0 object-cover w-full h-full transition-transform duration-300 transform group-hover:scale-110"
                />
                <div className="absolute px-2 py-1 text-sm font-semibold text-gray-700 bg-white rounded-lg top-6 left-5 font-poppins">
                  Coming soon
                </div>
                <div className="absolute inset-0 z-10 bg-gradient-to-t from-black to-transparent opacity-20"></div>
              </div>
              <div className="flex flex-col items-start p-4">
                <h3 className="text-lg text-black font-poppins">
                  {property.name}
                </h3>
                <div className="flex items-center justify-center mt-1">
                  <FontAwesomeIcon
                    icon={faLocationDot}
                    className="mr-2 text-sm text-gray-400"
                  />{" "}
                  <p className="text-sm text-gray-400 font-poppins">
                    {property.location}
                  </p>
                </div>
                <div className="flex gap-2 mt-2">
                  <p className="border rounded-lg text-[#173d73] border-[#173d73] px-2 font-poppins  text-sm">
                    Residential
                  </p>
                  <p className="border rounded-lg text-[#173d73] border-[#173d73] px-2 font-poppins  text-sm">
                    Commercial
                  </p>
                </div>
              </div>
            </div>
          ))}
        </section>
      </section>

      <Footer />
    </div>
  );
}

export default NewProjects;
